import { el } from "./dom.js";

// Toolbar control that flips a category list between its two layouts:
//   • Gallery (default) — the two-column masonry of cover tiles.
//   • List — a vertical stack of glass rows (cover · sticker + year · title ·
//     subline · rating), the shape Home's "Continue watching" uses.
//
// Sibling of group-toggle.js: the label shows the CURRENT layout and tapping
// flips it. The caller owns the state (it persists device-wide through
// utils/view-mode.js) and re-renders on `onChange(mode)`.
export function viewToggle({ mode = "gallery", onChange }) {
	let state = mode;
	const button = el("button.btn.btn--small.view-toggle", {
		type: "button",
		title: "Switch between the cover gallery and a list of rows",
	});

	function paint() {
		button.textContent = state === "list" ? "☰ List" : "▦ Gallery";
		button.setAttribute("aria-pressed", state === "list" ? "true" : "false");
	}

	button.onclick = () => {
		state = state === "list" ? "gallery" : "list";
		paint();
		onChange(state);
	};

	paint();
	return button;
}
